<template>
  <v-btn-toggle
    v-model="data"
    v-bind="$attrs"
    :multiple="multi"
  >
    <v-btn
      v-for="(d, index) in dayItems"
      :key="index"
      :value="d.value"
    >
      {{ d.label }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import ModelMixin from '../../mixins/model';

export default {
  mixins: [
    ModelMixin,
  ],

  props: {
    value: [Number, Array],
    multi: Boolean,
    stringValues: Boolean,
  },

  data() {
    return {
      data: undefined,
    };
  },

  computed: {
    dayItems() {
      const days = this.$t('common.daysOfWeek');
      let x = 0;
      return _.map(days, d => ({ label: d.short, value: this.stringValues ? d.value : x++ }));
    },
  },
};
</script>
